module.exports = __webpack_public_path__ + "static/cg_role_153_0017907a740.wav";